import { useState } from 'react';
import { Media } from '@weave/schema-gen-ts/dist/schemas/messaging/media/public/v1/service.pb';
import {
  UpdateConfigRequest,
  UpdateConfigResponse,
} from '@weave/schema-gen-ts/dist/schemas/phone/devices/config/device_config.pb';
import { UseMutateFunction } from 'react-query';
import { useTranslation } from '@frontend/i18n';
import { ImageGallery } from '@frontend/image-gallery';
import { theme } from '@frontend/theme';
import { Modal } from '@frontend/design-system';

type MediaConfigModalProps = {
  locationIds: string[];
  deviceId: string;
  closeModal: () => void;
  uploadConfig: UseMutateFunction<UpdateConfigResponse, unknown, UpdateConfigRequest, unknown>;
};
export const MediaConfigModal = ({ closeModal, locationIds, deviceId, uploadConfig }: MediaConfigModalProps) => {
  const { t } = useTranslation('phone', { keyPrefix: 'devices' });
  const [selectedImages, setSelectedImages] = useState<(Media | undefined)[]>([]);

  const upload = () => {
    uploadConfig({
      config: {
        wallpaperURL: selectedImages[0]?.url,
      },
      primitiveType: 'device',
      primitiveId: deviceId,
    });
  };

  return (
    <>
      <Modal.Header onClose={closeModal}>{t('Upload or Select a Background Image')}</Modal.Header>
      <Modal.Body>
        <ImageGallery
          locationIds={locationIds}
          handleImageSelect={(image) => {
            if (image && selectedImages.find((i) => image?.mediaId === i?.mediaId)) {
              // deselect the image
              setSelectedImages([]);
            } else {
              // select the new image
              setSelectedImages(image ? [image] : []);
            }
          }}
          imageSize='large'
          selectedImages={selectedImages}
          css={{
            '.image-gallery-content': {
              padding: theme.spacing(2),
            },
          }}
          trackingId={''}
        />
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: t('Save'),
          onClick: () => {
            upload();
          },
        }}
        secondary={{
          label: t('Cancel'),
          onClick: () => {
            setSelectedImages([]);
            closeModal();
          },
        }}
      />
    </>
  );
};
